import axiosRequest from 'axios'

import { AUTH_API_URL } from '@/constants'

export const authInstance = axiosRequest.create({
  baseURL: `${AUTH_API_URL}api`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

// http://localhost:5007/api/Auth/login
